export const debounce = (method, delay, args = []) => {
  clearTimeout(method._tId);
  method._tId = setTimeout(function() {
    method(...args);
  }, delay);
};
